<script setup lang="ts">
import type { PortableTextTextBlock, Image } from '@sanity/types';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    url: string;
    title: string;
    theme: string;
    preTitle: string;
    ctaLabel: string;
    description: Array<PortableTextTextBlock>;
    descriptionUnhappy: Array<PortableTextTextBlock>;
    image?: Image;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  url: props.block?.url,
  title: props.block?.title,
  preTitle: props.block?.preTitle,
  ctaLabel: props.block?.ctaLabel,
  description: props.block?.description,
  descriptionUnhappy: props.block?.descriptionUnhappy,
  image: props.block?.image,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
